import React from 'react';
import { useSelector } from 'react-redux';

export default function usePayoutSelector() {
  const PayoutListData = useSelector((state) => state.Payout.list_data?.Payout) || []; // List data
  const PayoutViewData = useSelector((state) => state.Payout.view_data) || []; // view data
  const PayoutCommentLog =
    useSelector((state) => state.Payout.comment_log?.partnerPayoutCommentLogs) || []; // comment log
  const AdvancePayoutListData =
    useSelector((state) => state.Payout.advance_list_data?.Payout) || []; // advance list data
  const PayoutSummaryData = useSelector((state) => state.Payout.summary_list_data) || []; // List data
  const PayoutNetworkData = useSelector((state) => state.Payout.network_list_data) || []; // List data
  const PayoutPLData = useSelector((state) => state?.Payout?.pl_list_data) || []; // List data
  const PayoutProfileData = useSelector((state) => state?.Payout?.profile_list_data) || []; // List data
  const NetworkViewData = useSelector((state) => state?.Payout?.network_view_data) || null; // view data

  const AdvancePendingViewData =
    useSelector((state) => state.Payout.advance_pending_list_data) || []; // List data

  return {
    PayoutListData,
    PayoutCommentLog,
    PayoutViewData,
    AdvancePayoutListData,
    PayoutSummaryData,
    PayoutNetworkData,
    AdvancePendingViewData,
    PayoutPLData,
    PayoutProfileData,
    NetworkViewData,
    PaymentMethodData: useSelector((state) => state.Payout.payment_method),
    PaymentTypesData: useSelector((state) => state.Payout.payment_types) || []
  };
}
